import { Box, Divider, Grid, useMediaQuery, useTheme } from '@mui/material'
import ProfileSectionHeader from 'components/common/ProfileSectionHeader/ProfileSectionHeader';
import useGlobalStyles from 'styles/globalStyles'
import AddPositionButton from '../AddPositionButton/AddPositionButton';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { colors } from 'styles/colors';
import { useProfileContext } from 'context/ProfileContext';
import PositionItem from '../PositionItem/PositionItem';
import PositionItemSkeleton from '../PositionItemSkeleton/PositionItemSkeleton';
import { hexWithOpacity } from 'common/utils';
import CustomText from 'components/common/CustomText/CustomText';

export default function Positions() {
  const globalStyles = useGlobalStyles();
  const { positions, isLoading } = useProfileContext();
  const showSkeleton = isLoading && positions.length === 0;

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Current Position'}
          icon={<WorkOutlineIcon sx={{ fontSize: 18, color: colors.primary }} />}
          buttons={[
            <AddPositionButton key='position' entity={'position'} />
          ]}
        />
      </Box>

      <Divider />

      <Grid
        container
        spacing={1.5}
        p={2}
        sx={{
          flexGrow: showSkeleton || positions.length > 0 ? 0 : 1,
          display: 'flex',
        }}
      >
        {showSkeleton ? (
          Array.from({ length: 12 }).map((_, index) => (
            <Grid
              key={index}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <PositionItemSkeleton />
            </Grid>
          ))
        ) : positions?.length === 0 ? (
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              textAlign="center"
              gap={2}
            >
              <Box height={100}>
                <WorkOutlineIcon
                  sx={{ fontSize: 100, color: hexWithOpacity(colors.secondary, 0.5) }}
                />
              </Box>
              <CustomText
                text='No position added yet'
                color={colors.secondary}
              />
            </Box>
          </Grid>
        ) : (
          positions.map((item: any) => (
            <Grid
              key={item.id}
              size={{
                xs: 12,
                lg: 6,
                xl: 4,
              }}
            >
              <PositionItem item={item} />
            </Grid>
          ))
        )}
      </Grid>

    </Box>
  )
}
